export let routes = [
  {
    path: '/x3-side-relation',
    name: 'x3-side-relation',
    component: () => import('@x3/js/side/relation/relation.vue'),
    meta: {
      vx_animate: 'none',
    },
  },
];
  
export let api = {
  xsRelation(options) {
    return new Promise((resolve, reject) => {
      app.router.push(
        '/x3-side-relation',
        route => {
          route.meta._resolve = resolve;
          route.meta._reject = reject;
          route.meta.options = options;
        },
        err => {
          console.log(err);
        }
      );
    });
  },
};